<template>
    <div class="block">
        <div class="" style="position: relative;" @dragover.prevent="isDragging = true" @dragleave.prevent="isDragging = false" @drop="handleFileDrop($event, id)">
            <div class="upload-container" :class="{ 'drag-over': isDragging }">
                <input
                    id="formFile"
                    class="upload-dropzone"
                    type="file"
                    @change="handleFileUploads($event, id)"
                    multiple
                />
            </div>
            <label v-if="!isDragging" class="upload-title" for="formFile">
                <img src="../../assets/images/drag-and-drop.svg" alt="">
                <span>Drag and drop or click to upload</span>
            </label>

            <label v-if="isDragging" class="upload-title" for="formFile">
                <img src="../../assets/images/drag-and-drop-hover.svg" alt="">
                <span class="is-dragging">Drag and drop or click to upload</span>
            </label>
        </div>
    </div>
</template>

<script>
import { api } from "@/mixins/axios";

export default {
    name: "UploadContainer",
    props: ["id"],
    data: function () {
        return {
            files: null,
            isDragging: false
        };
    },
    methods: {
        handleFileUploads(event, id) {
            console.log(id)
            this.files = event.target.files;
            this.$emit('upload', this.files, id)
        },
        handleFileDrop(event, id) {
            console.log(id)
            event.preventDefault();
            this.isDragging = false;
            this.files = event.dataTransfer.files;
            this.$emit('upload', this.files, id)
        }
    },
};
</script>

<style scoped lang="scss">
.upload-container {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 5px;
    cursor: pointer;
    margin: 10px 0;
    height: 106px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23999999FF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 10px;

    &.drag-over {
        background-color: #808080;
    }
}
.is-dragging {
    color: #9BDBFF;
}

.upload-container * {
    opacity: 0;
}

.upload-dropzone {
    cursor: pointer;
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 5px;
}

.upload-title {
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #FFFFFF80;
    font-weight: 400;
    gap: 6px;
    width: 100%;

    i {
        font-size: 30px;
    }
}
</style>
